export const of_booking_displayed_columns_locale = {
  id: "Booking ID",
  contractNumber: "Contract nr.",
  freightPayable: "Freight payable at",
  freightTariffNumber: "Freight tariff nr.",
  hasCarrierAMSFiling: "Carrier AMS filing",
  status: "Status"
};
